export default __webpack_public_path__ + "static/media/icons8-pencil.48737d17.svg";